<template>
  <div class="rt-lookup" style="display:block">
    <el-input readonly :disabled="disabled" v-model="lookupValue.name" :placeholder="$tx(
                              'Please Select',
                              'common.select'
                            )">
    <!-- <el-autocomplete :readonly="readonly"
     v-model="lookupValueName"
       :disabled="disabled"
     :trigger-on-focus="false"
        @select="selectValue"
         placeholder
      style="width:100%"
    > -->
      <i slot="suffix" class="el-input__icon el-icon-search"  @click="showLookupDialog"></i>
      </el-input>
    <!-- </el-autocomplete> -->
    <rt-lookup-dialog
      ref="lookupDialog"
      :entity="entity"
      :request-url="dialogRequestUrl"
      :name-field="nameField"
      :id-field="idField"
      :display-fields="dialogDisplayFields"
      :orderby-fields="dialogOrderbyFields"
      :custom-conditions="dialogCustomConditions"
      :filter-fields="dialogFilterFields"
      :return-fields="dialogReturnFields"
      @data-selected="handleDataSelected"
      :dialogCallback="dialogCallback"
    ></rt-lookup-dialog>
  </div>
</template>

<script>
import RtLookupDialog from "./lookup-dialog";

export default {
  name: "RtNewLookup",
  props: {
    value: {
      type: Object,
      required: false
    },
    disabled: Boolean,
    entity: {
      type: String,
      required: true
    },
    nameField: String,
    idField: String,
    dialogRequestUrl: String,
    dialogDisplayFields: Array,
    dialogOrderbyFields: String,
    dialogFilterFields: String,
    dialogCustomConditions: String,
    dialogReturnFields: String,
    dialogCallback: Function
  },
  components: {
    "rt-lookup-dialog": RtLookupDialog
  },
  computed: {},
  data() {
    return {
      lookupValue: {},
      lookupValueName: null
    };
  },
  watch: {
    value(newValue) {
      this.lookupValue = newValue || {};
      this.lookupValueName = this.lookupValue.name;
    },
    lookupValueName(newValue, oldValue) {
      if (newValue == "" || newValue == null) {
        this.lookupValue = {
          name: null,
          id: null,
          logicalname: null
        };
        this.$emit("input", this.lookupValue);
        if (this.dialogCallback) {
          this.dialogCallback(this.lookupValue);
        }
      }
    }
  },
  mounted() {
    if (this.value) {
      this.lookupValue = this.value;
    }
  },
  methods: {
    showLookupDialog() {
      if (this.disabled) {
        return;
      }

      this.$refs.lookupDialog.show();
    },
    handleDataSelected(val) {
      this.lookupValue = val;
      this.lookupValueName = val.name;
      this.$emit("input", val);

      this.$emit("change", val);
    },
    selectValue(value) {
      if (value) {
        this.lookupValue = {
          name: value[this.nameField],
          id: value[this.idField],
          logicalname: this.entity
        };
        // 重命名value中的id和name
        value["name"] = value[this.nameField];
        value["id"] = value[this.idField];
        value["logicalname"] = this.entity;
        // delete value[this.nameField];
        // delete value[this.idField]
        this.lookupValueName = this.lookupValue.name;
        this.$emit("input", this.lookupValue);
        if (this.dialogCallback) {
          this.dialogCallback(value);
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// lookup.vue?7bfc4da4